import { useHomeStore } from "../home/state/store";
import { usePortalStore } from "../vend/contactPortal/state/store";
import { useActionOverlayStore } from "../vend/state/actionOverlay";
import { useNavHistory } from "../vend/state/navHistory";
import { useRoutePlannerStore } from "../vend/state/routePlanner";
import { useToastStore } from "../vend/state/toast";
import { useVendStore } from "../vend/state/store";
import { useEntityDraftStore } from "../vend/state/entityDrafts";
import { useExpenseStore } from "../vend/state/expense/store";
import { useLiveSalesStore } from "../vend/liveSales/store";
import { runRegisteredStoreResets } from "./resetRegistry";
import { useAdministrationStore } from "../vend/administration/store";
import { useMarketplaceAdministrationStore } from "../vend/administration/marketplace/state/store";
import { useExecutionLocationStore } from "../vend/state/executionLocations";

export const resetAllStores = () => {
  runRegisteredStoreResets();
  useVendStore.getState().reset();
  useRoutePlannerStore.getState().reset();
  usePortalStore.getState().reset();
  useHomeStore.getState().reset();
  useNavHistory.getState().clear();
  useToastStore.getState().clear();
  useActionOverlayStore.getState().reset();
  useEntityDraftStore.getState().reset();
  useExpenseStore.getState().reset();
  useLiveSalesStore.getState().reset();
  useAdministrationStore.getState().reset();
  useMarketplaceAdministrationStore.getState().reset();
  useExecutionLocationStore.getState().reset();
};
